import { Injectable } from "@angular/core";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import omit from "lodash/omit";
import jwtDecode from "jwt-decode";
import { PUBLIC_IN_PRACTICE_JWT_STORAGE_KEY } from "@apps/patient-core/src/app/services/abstracts/jwt.service";
import { Constants } from "@apps/concierge-app/constants";

export interface I_ConciergeData {
  practiceName: string;
  region: string;
  siteId: string;
  siteName: string;
  siteUrl: string;
  stage: string;
  jwt: string;
  deviceDirections: string;
}

@Injectable({
  providedIn: "root",
})
export class ConciergeDataService {
  public get publicInPracticeToken(): Record<string, any> | null {
    try {
      const token = this._cacheService.get(PUBLIC_IN_PRACTICE_JWT_STORAGE_KEY);
      if (!token) return null;
      return jwtDecode(token);
    } catch (e) {
      return null;
    }
  }
  constructor(private _cacheService: CacheService) {}

  public setConciergeData(data: I_ConciergeData) {
    this._cacheService.set(Constants.CONCIERGE_DATA_STORAGE_KEY, JSON.stringify(omit(data, "jwt")));
  }

  public getConciergeData(): I_ConciergeData | null {
    const json = this._cacheService.get(Constants.CONCIERGE_DATA_STORAGE_KEY);
    if (!json) return null;
    const data = JSON.parse(json) as I_ConciergeData;

    if (data.stage === "p-euapac-a1") {
      data.stage = "p-apse2-a1";
      data.region = "ap-southeast-2";

      this.setConciergeData(data);
    }

    return data;
  }

  public hasConciergeData(): boolean {
    return this.getConciergeData() !== null;
  }

  public deleteConciergeData(): void {
    this._cacheService.delete(Constants.CONCIERGE_DATA_STORAGE_KEY);
  }

  public setConciergeDataSiteUrl(siteUrl: string): void {
    const dataString = this._cacheService.get(Constants.CONCIERGE_DATA_STORAGE_KEY);
    if (!dataString) throw new Error("Can't update site url without existing concierge data");
    const data = JSON.parse(dataString) as I_ConciergeData;
    data.siteUrl = siteUrl;

    this._cacheService.set(Constants.CONCIERGE_DATA_STORAGE_KEY, JSON.stringify(data));
  }
}
